import { getCoreDataSecurityApplicationOverviewSlice } from './get';

export const { requestGetCoreDataSecurityApplicationOverview, resetGetCoreDataSecurityApplicationOverview } =
getCoreDataSecurityApplicationOverviewSlice.asyncActionCreators;
